import { render, staticRenderFns } from "./FormCustomerSelect.vue?vue&type=template&id=879b542a&scoped=true&"
import script from "./FormCustomerSelect.vue?vue&type=script&lang=js&"
export * from "./FormCustomerSelect.vue?vue&type=script&lang=js&"
import style0 from "./FormCustomerSelect.vue?vue&type=style&index=0&id=879b542a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879b542a",
  null
  
)

export default component.exports